export const lavendar = '#967BB6';
export const mint = '#B6FFBB';
export const sage = '#80968B';
export const cream = '#F6F7EC';

export const mintGreen = '#ADEBB3';
export const seafoam = '#9FE2B2';

export const coffee = '#6F4E37';
export const bistre = '#3D2B1F';

export const lavendarWeb = '#E6E6FA';
export const lavendarFloral = '#B57EDC';

export const royalPurple = '#7851A9';
export const periwinkle = '#CCCCFF';

export const emerald = '#50C878';
export const darkSpringGreen = '#177245';


